import { AbstractControl, AsyncValidator, AsyncValidatorFn, ValidationErrors } from '@angular/forms';
import { catchError, map, Observable, of } from 'rxjs';
import { MasterDataService } from '../../../../services/master-data.service';
import { ToastrService } from '../../../../services/toastr-service';
import { inject, Injectable } from '@angular/core';
import { AemsValidationError } from '../../../../models/aems-validation-error.model';

@Injectable({ providedIn: 'root' })
export class EquipmentMaximumRepairCostValidator implements AsyncValidator {
  private masterDataService: MasterDataService;
  private toastrService: ToastrService;
  constructor() {
    this.masterDataService = inject(MasterDataService);
    this.toastrService = inject(ToastrService);
  }
  validate(control: AbstractControl): Observable<AemsValidationError | null> {
    const equipmentNumber = control.value;
    if (equipmentNumber) {
      return this.masterDataService.getEquipmentRemark(equipmentNumber).pipe(
        map((result) => {
          if (result) {
            if (result.displayRemark === true && result.maximumRepairCost === 0) {
              return { equipmentMaximumRepairCostValidator: { error: result.message } };
            } else if (result.displayRemark === true && (result.maximumRepairCost === null || result.maximumRepairCost)) {
              this.toastrService.showToastr(result.message, 'warning', { duration: 60000 });
              return null;
            }
          }
          return null;
        }),
        catchError((error) => {
          return of({ equipmentMaximumRepairCostValidator: { error: 'Unable to verify maximum repair limit for this equipment' } });
        }),
      );
    } else {
      return of(null);
    }
  }
}
